var _rect, _circle, _circle2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentOperationalFrictionDarkBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1600,
    height: 1000,
    viewBox: "0 0 1600 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom development operational friction dark background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "#020716"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1500,
    cy: 100,
    r: 410,
    fill: "#087CFF",
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 930,
    r: 260,
    fill: "#FF2775",
    opacity: 0.065
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#5DB3FF",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1280,
    cy: 240,
    r: 230
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1280,
    cy: 240,
    r: 310
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 910L1460 80"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#74BDFF",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 160,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 760,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1440,
    cy: 520,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentOperationalFrictionDarkBackground);
export default __webpack_public_path__ + "static/media/custom-development-operational-friction-dark-background.c622b0003e44c31fb27f145dd5833387.svg";
export { ForwardRef as ReactComponent };